module.exports = __webpack_public_path__ + "static/media/Extra@3x.a29a56d3.png";